import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { toast } from "sonner";
import { Seo } from "@/components/Seo";
import { errText, resetPassword } from "@/lib/api";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const [pw, setPw] = useState("");
  const [done, setDone] = useState("");
  const submit = async (e) => {
    e.preventDefault();
    try { setDone((await resetPassword({ token: params.get("token"), password: pw })).message); } catch (err) { toast.error(errText(err)); }
  };
  return (
    <div className="mx-auto max-w-xl px-5 py-24 sm:px-10" data-testid="reset-page">
      <Seo title="Reset password" description="Reset your password at the suspects." path="/account/reset" noindex />
      <h1 className="display text-[clamp(3rem,8vw,6rem)]">New <span className="hl hl-sky hl-thick">password</span></h1>
      {done ? (
        <div className="mt-10 rounded-[24px] bg-lime p-6"><p data-testid="reset-done">{done}</p><Link to="/account" className="btn btn-ink mt-6" data-testid="reset-login-link">Log in <ArrowRight size={16} /></Link></div>
      ) : (
        <form onSubmit={submit} className="mt-10 space-y-5">
          <label className="block"><span className="label text-ink/60">New password (8+ characters)</span><input type="password" minLength={8} required value={pw} onChange={(e) => setPw(e.target.value)} className="field" autoComplete="new-password" data-testid="reset-password" /></label>
          <button className="btn btn-ink" data-testid="reset-submit">Update password <ArrowRight size={16} /></button>
        </form>
      )}
    </div>
  );
}
